import type { ReactNode } from 'react';
import type { WorkspaceMode } from './ShellLayoutContext';

interface WorkspaceProps {
  mode: WorkspaceMode;
  children: ReactNode;
}

export function Workspace({ mode, children }: WorkspaceProps) {
  return (
    <main
      className={`primary-workspace workspace--${mode}`}
      data-testid="primary-workspace"
      data-workspace-mode={mode}
    >
      {children}
    </main>
  );
}
